module.exports = __webpack_public_path__ + "static/media/in-love-emoji-svgrepo-com (1).36d77e8a.svg";